import { render, staticRenderFns } from "./documents-toolbar.vue?vue&type=template&id=113cf7f3"
import script from "./documents-toolbar.vue?vue&type=script&lang=js"
export * from "./documents-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports